import React from 'react'
import { withIcon } from '../../withIcon'

function SlidePrevIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.5 18.5793L14.5 5.42024C14.5 5.25505 14.4158 5.10438 14.2856 5.03629C14.1564 4.96933 14.0042 4.99611 13.8979 5.10772L7.61414 11.6872C7.46195 11.8457 7.46195 12.1538 7.61414 12.3134L13.8979 18.8918C14.0042 19.0034 14.1564 19.0313 14.2856 18.9632C14.4158 18.8962 14.5 18.7456 14.5 18.5793Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SlidePrevIcon)
